import React from 'react';
import Modal from '../../Components/Modal';
import Form, { Actions, DateTime, EventTriggers, OptionalTime, RequiredValidator, User } from '../../Components/Form';
import { useCustomer } from '../../Data/Customers';
import { eventTriggers } from '../../Data/Misc';

const ScheduleJob = ({job, onClose, then}) => {
    return <Modal title="Schedule job" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner job={job} then={then} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {scheduleJob} = useCustomer(job?.customerId);
    const formData = {date: job?.scheduledDate, estimatedTime: job?.estimatedTime, assignedTo: job?.assignedTo};

    return <Form data={formData}
            onSubmit={d => scheduleJob(job.id, d)}
            afterSubmit={then}
            closeModalOnSubmit
        >
        <DateTime name="date" label="Date" time={false} validators={[RequiredValidator]} showDatePrompts />
        <OptionalTime name="estimatedTime" label="Time" toggleLabel="Set a time for the job" step="300" />
        <User name="assignedTo" label="Assign to" validators={[]} />
        <EventTriggers triggers={[eventTriggers.SEND_NOTIFICATIONS]} />
        <Actions submit={{label: 'Schedule'}} cancel />
    </Form>
}

export default ScheduleJob;
